module.exports = __webpack_public_path__ + "img/dp04.48bb0acb.png";